<div class="alert alert-ghost flex-lg flex-md flex-sm flex--space-between">
  <div>
    <p class="text-caption margin-bottom-8">You are logged in as</p>
    <div class="flex-always">
      <div>
        <img src="./images/user/user-default.png" class="img-circle margin-right-8" width="32" height="32" alt="{{ user.currentUser.firstName }}">
      </div>
      <div>
        <strong>{{user.currentUser.firstName}}</strong><br>
        <span class="text-muted-light">{{user.currentUser.emailAddress}}</span>
      </div>
    </div>
  </div>
  <a class="link text-nowrap" href="javascript:void(0)" (click)="logout()">Log out</a>
</div>